import * as api from "@/api/williams/tests";
import { queryKeys } from "../../queryKeys";
import { useMutation, useQueryClient } from "react-query";

export function usePinTest() {
  const queryClient = useQueryClient();

  return useMutation(async (id: string) => {
    await api.togglePinned(id);
    queryClient.refetchQueries(queryKeys.standardTests.list());
  });
}
